import React, { useState, useEffect } from 'react';

export default function CRPHeaderBlock({ studentFirstName, studentLastName, date }) {
  const [formattedDate, setFormattedDate] = useState();

  useEffect(() => {
    setFormattedDate(formatDate(date));
  }, [date]);
  

  function formatDate(timestamp) {
    const date = new Date(timestamp);
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    let dateString = date.toLocaleString('en-US', options);
  
    // Function to add the ordinal suffix to the day
    function getOrdinalSuffix(day) {
      if (day > 3 && day < 21) return 'th'; // for numbers between 11 and 20
      switch (day % 10) {
        case 1: return 'st';
        case 2: return 'nd';
        case 3: return 'rd';
        default: return 'th';
      }
    }
  
    // Extract the day from the date and add the ordinal suffix
    const day = date.getDate();
    const dayWithSuffix = day + getOrdinalSuffix(day);
  
    // Replace the day number with the day with suffix in the date string
    dateString = dateString.replace(day, dayWithSuffix);
  
    return dateString;
  }
  
  return (
    <div className='header'>Comprehension Dialogue review for {studentFirstName} {studentLastName} on {formattedDate}</div>
  )
}